function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import Draft, { Editor, EditorState, SelectionState, RichUtils, convertToRaw, convertFromRaw, CompositeDecorator, ContentState } from 'draft-js';
import { createGlobalStyle } from 'styled-components';
import { debounce } from '@finect/front-utils/debounce';
import { EditButton, DeleteButton, SaveButton, CancelButton, DeleteContent } from '@finect/tabular-components/EditionActions';
import { editorStyles, styleMap, extendedBlockRenderMap, keyBindings, LimitChars, EditionButtons, addImage, addVideo, customBlockRenderer } from './partials';
import { Toolbar, EditorControls, LinkControl, VideoLinkControl } from './controls';
import { getStateFromLocal, getStateFromProps } from './getState';
import { limit, inlink, link, mentions, products, questionSuggestion } from './decorators';
import { EditorContainer, DragnDrop } from './EditorContainer';
export var EditorGlobalStyles = createGlobalStyle(["", ""], editorStyles);
export var EntryEditor = function (_React$Component) {
  _inherits(EntryEditor, _React$Component);
  var _super = _createSuper(EntryEditor);
  function EntryEditor() {
    var _this;
    _classCallCheck(this, EntryEditor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "callbacks", {});
    _defineProperty(_assertThisInitialized(_this), "container", void 0);
    _defineProperty(_assertThisInitialized(_this), "fileInput", void 0);
    _defineProperty(_assertThisInitialized(_this), "state", {
      editorState: _this.props.content ? getStateFromProps(_this.props.content) : EditorState.createEmpty(),
      showLink: false,
      showVideoLink: false,
      isEditing: !_this.props.readOnly,
      isTooLong: false,
      loadLocal: false,
      dragging: false
    });
    _defineProperty(_assertThisInitialized(_this), "loadDecorators", function () {
      var decorators = _this.props.decorators;
      var editorDec = [];
      if (decorators.includes('mentions')) {
        editorDec.push(_objectSpread(_objectSpread({}, mentions), {}, {
          props: {
            editor: _assertThisInitialized(_this)
          }
        }));
      }
      if (decorators.includes('products')) {
        editorDec.push(_objectSpread(_objectSpread({}, products), {}, {
          props: {
            editor: _assertThisInitialized(_this)
          }
        }));
      }
      if (decorators.includes('link')) editorDec.push(link);
      if (decorators.includes('inlink')) editorDec.push(inlink);
      if (decorators.includes('limit') && _this.props.limit) {
        editorDec.push(limit(_this.props.limit.chars));
      }
      if (decorators.includes('questionSuggestion')) {
        editorDec.push(_objectSpread(_objectSpread({}, questionSuggestion), {}, {
          props: {
            editor: _assertThisInitialized(_this)
          }
        }));
      }
      return editorDec;
    });
    _defineProperty(_assertThisInitialized(_this), "addEntity", function (entity) {
      var editorState = _this.state.editorState;
      var contentState = editorState.getCurrentContent();
      var rawContent = convertToRaw(contentState);
      var entities = rawContent.entityMap;
      var exists = Object.keys(entities).some(function (key) {
        return entities[key].type === entity.type && entities[key].data.id === entity.data.id;
      });
      if (exists) return;
      var selectionState = contentState.getSelectionAfter();
      var newEntity = contentState.createEntity(entity.type, entity.mutability, entity.data);
      var entityKey = newEntity.getLastCreatedEntityKey();
      var newContentState = Draft.Modifier.insertText(newEntity, selectionState.merge({
        anchorOffset: 0,
        focusOffset: 0
      }), entity.data.name, null, entityKey);
      var newEditorState = Draft.EditorState.push(editorState, newContentState, 'insert-characters');
      var editorStateToUpdate = Draft.EditorState.forceSelection(newEditorState, newContentState.getSelectionAfter());
      _this.setState({
        editorState: editorStateToUpdate
      });
    });
    _defineProperty(_assertThisInitialized(_this), "cleanEditor", function () {
      var newEditorState = Draft.EditorState.push(_this.state.editorState, ContentState.createFromText(''), 'undo');
      _this.setState({
        editorState: newEditorState
      }, function () {
        setTimeout(function () {
          return _this.props.focusEditor && _this.props.focusEditor();
        }, 0);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "blockRendererFn", function (contentBlock) {
      return customBlockRenderer(contentBlock, _this.state.editorState);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleBlockType", function (blockType) {
      _this.handleChange(RichUtils.toggleBlockType(_this.state.editorState, blockType));
    });
    _defineProperty(_assertThisInitialized(_this), "toggleInlineStyle", function (inlineStyle) {
      _this.handleChange(RichUtils.toggleInlineStyle(_this.state.editorState, inlineStyle));
    });
    _defineProperty(_assertThisInitialized(_this), "showLink", function () {
      _this.setState(function (state) {
        return {
          showLink: !state.showLink
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "showVideoLink", function () {
      _this.setState(function (state) {
        return {
          showVideoLink: !state.showVideoLink
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hideLink", function () {
      _this.setState({
        showLink: false
      }, function () {
        setTimeout(function () {
          return _this.props.focusEditor && _this.props.focusEditor();
        }, 0);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hideVideoLink", function () {
      _this.setState({
        showVideoLink: false
      }, function () {
        setTimeout(function () {
          return _this.props.focusEditor && _this.props.focusEditor();
        }, 0);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "saveContent", debounce(function (content) {
      var _this$props = _this.props,
        name = _this$props.name,
        handleRemoveProduct = _this$props.handleRemoveProduct;
      if (handleRemoveProduct) {
        var editorState = _this.state.editorState;
        var contentState = editorState.getCurrentContent();
        var rawContent = convertToRaw(contentState);
        var entities = rawContent.entityMap;
        var newProducts = [];
        Object.keys(entities).forEach(function (key) {
          if (entities[key].type === 'PRODUCT_MENTION') {
            newProducts.push(entities[key].data.id);
          }
          return '';
        });
        handleRemoveProduct(newProducts);
      }
      if (!name) return;
      localStorage.setItem(name, JSON.stringify({
        content: JSON.stringify(convertToRaw(content)),
        timestamp: new Date().getTime()
      }));
    }, 250));
    _defineProperty(_assertThisInitialized(_this), "renderLimit", function () {
      var editorState = _this.state.editorState;
      var _this$props$limit = _this.props.limit,
        chars = _this$props$limit.chars,
        extraPadding = _this$props$limit.extraPadding;
      var contentState = editorState.getCurrentContent();
      var plainText = contentState.getPlainText('');
      var currentStatus = Math.abs(chars - plainText.length);
      var isLimit = plainText.length > chars;
      return React.createElement(LimitChars, {
        isLimit: isLimit,
        extraPadding: extraPadding,
        title: isLimit ? "Has superado el l\xEDmite en ".concat(currentStatus, " caracteres") : "Te quedan ".concat(currentStatus, " caracteres")
      }, currentStatus);
    });
    _defineProperty(_assertThisInitialized(_this), "getCharCount", function (editorState) {
      var contentState = editorState.getCurrentContent();
      var plainText = contentState.getPlainText('');
      if (plainText.length >= _this.props.limit.chars - 20) {
        _this.setState({
          isTooLong: true
        });
      } else {
        _this.setState({
          isTooLong: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      var _this$props2 = _this.props,
        handleFocus = _this$props2.handleFocus,
        focusEditor = _this$props2.focusEditor;
      if (handleFocus) return handleFocus();
      focusEditor && focusEditor();
    });
    _defineProperty(_assertThisInitialized(_this), "handleAddEntity", function (item) {
      _this.props.handleAddProduct && _this.props.handleAddProduct(item);
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (editorState) {
      if (!_this.state.loadLocal) return;
      var handleChange = _this.props.handleChange;
      var contentState = editorState.getCurrentContent();
      _this.saveContent(contentState);
      _this.setState({
        editorState: editorState
      });
      if (_this.props.limit) _this.getCharCount(editorState);
      if (handleChange) {
        handleChange(contentState.getPlainText().trim());
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleEscape", function (event) {
      if (_this.callbacks.onEscape) {
        event.preventDefault();
        _this.callbacks.onEscape();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleUpArrow", function (event) {
      if (_this.callbacks.onUpArrow) {
        event.preventDefault();
        _this.callbacks.onUpArrow();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleDownArrow", function (event) {
      if (_this.callbacks.onDownArrow) {
        event.preventDefault();
        _this.callbacks.onDownArrow();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleTab", function (event) {
      if (_this.callbacks.onTab) {
        event.preventDefault();
        _this.callbacks.onTab();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleReturn", function () {
      if (_this.callbacks.onReturn) {
        _this.callbacks.onReturn();
        return 'handled';
      }
      if (_this.props.handleReturn) {
        _this.props.handleReturn(_this.cleanEditor);
        return 'handled';
      }
      return 'not-handled';
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyCommand", function (command, editorState) {
      var newState = RichUtils.handleKeyCommand(editorState, command);
      var handleBackspace = _this.props.handleBackspace;
      if (command === 'backspace' && handleBackspace) {
        handleBackspace();
      }
      if (newState) {
        _this.handleChange(newState);
        return 'handled';
      }
      return 'not-handled';
    });
    _defineProperty(_assertThisInitialized(_this), "handleDragLeave", function () {
      _this.setState({
        dragging: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDragOver", function (event) {
      !_this.state.dragging && _this.setState({
        dragging: true
      });
      var isEditorContainer = event.target.classList.value.includes('EditorContainer');
      var isImageBlock = event.target.classList.value.includes('ImageBlock');
      if (!_this.props.decorators.includes('images') || isEditorContainer || isImageBlock) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleAddImage", function (event) {
      if (!_this.props.decorators.includes('images')) return null;
      event.preventDefault();
      event.stopPropagation();
      var dataTransferItemsList = {};
      if (event.dataTransfer) {
        var dt = event.dataTransfer;
        if (dt.files && dt.files.length) {
          dataTransferItemsList = dt.files;
        } else if (dt.items && dt.items.length) {
          dataTransferItemsList = dt.items;
        }
      } else if (event.target && event.target.files) {
        dataTransferItemsList = event.target.files;
      }
      var droppedFiles = Object.keys(dataTransferItemsList).map(function (key) {
        return dataTransferItemsList[key];
      });
      _this.handleDroppedFiles(null, droppedFiles);
    });
    _defineProperty(_assertThisInitialized(_this), "openFileDialog", function () {
      _this.fileInput && _this.fileInput.click();
    });
    _defineProperty(_assertThisInitialized(_this), "handleDroppedFiles", function (selection, files) {
      if (!_this.props.decorators.includes('images')) return null;
      var attachment = {
        files: []
      };
      files.map(function (file) {
        if (file && file instanceof File && file.type.includes('image')) {
          attachment.files.push(file);
        } else {
          alert('Tipo de fichero no soportado.');
          return null;
        }
      });
      var updateImage = function updateImage(entityKey, newData) {
        var editorState = _this.state.editorState;
        var contentState = editorState.getCurrentContent();
        contentState.replaceEntityData(entityKey, newData);
        var newEditorState = EditorState.push(editorState, contentState, 'change-block-data');
        _this.setState({
          editorState: newEditorState
        });
      };
      var editorState = _this.state.editorState;
      attachment.files.map(function (file) {
        editorState = addImage(editorState, URL.createObjectURL(file), {
          name: file.name,
          updateImage: updateImage,
          file: file
        });
      });
      _this.setState({
        editorState: editorState,
        dragging: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleAddVideo", function (url) {
      var editorState = _this.state.editorState;
      editorState = addVideo(_this.state.editorState, url);
      _this.setState({
        editorState: editorState
      });
    });
    _defineProperty(_assertThisInitialized(_this), "cancelEdition", function () {
      try {
        var content = _this.props.content;
        if (content) {
          var data = content.type === 'blocks' ? convertFromRaw(JSON.parse(content.body)) : ContentState.createFromText(content.body);
          var newEditorState = Draft.EditorState.push(_this.state.editorState, data, 'undo');
          setTimeout(function () {
            return _this.setState({
              editorState: newEditorState
            });
          }, 0);
        }
      } catch (err) {
        console.log('Parse error');
      }
      _this.toggleEditing();
    });
    _defineProperty(_assertThisInitialized(_this), "saveEdition", function () {
      _this.props.handleEdition && _this.props.handleEdition();
      _this.toggleEditing();
    });
    _defineProperty(_assertThisInitialized(_this), "toggleEditing", function () {
      if (!_this.state.isEditing) {
        _this.props.focusEditor && _this.props.focusEditor();
      }
      _this.props.handleToggleEditing && _this.props.handleToggleEditing();
      _this.setState(function (state) {
        return {
          isEditing: !state.isEditing
        };
      });
    });
    return _this;
  }
  _createClass(EntryEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
        name = _this$props3.name,
        content = _this$props3.content;
      var editorState = !this.state.loadLocal && name && !content ? getStateFromLocal(name) : content ? getStateFromProps(this.props.content) : this.state.editorState;
      var decorators = this.loadDecorators();
      if (decorators.length) {
        var decorator = new CompositeDecorator(decorators);
        this.setState({
          editorState: EditorState.set(editorState, {
            decorator: decorator
          }),
          loadLocal: true
        });
      }
      if (this.props.entity) {
        this.addEntity(this.props.entity);
      }
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var editorState = this.state.editorState;
      var decorators = this.loadDecorators();
      if (decorators.length) {
        var decorator = new CompositeDecorator(decorators);
        this.setState({
          editorState: EditorState.set(editorState, {
            decorator: decorator
          })
        });
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.entity && !this.props.entity) {
        this.addEntity(nextProps.entity);
      }
      if (!nextProps.forceEdition) return;
      if (this.props.forceEdition && this.props.forceEdition.isEditing !== nextProps.forceEdition.isEditing) {
        if (nextProps.forceEdition.forceCancel) {
          this.cancelEdition();
        } else {
          this.toggleEditing();
        }
      }
      if (this.props.content && nextProps.content && this.props.content.body !== nextProps.content.body) {
        var data = nextProps.content.type === 'blocks' ? convertFromRaw(JSON.parse(nextProps.content.body)) : ContentState.createFromText(nextProps.content.body);
        var newEditorState = Draft.EditorState.push(this.state.editorState, data, 'undo');
        this.setState({
          editorState: newEditorState
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        editorState = _this$state.editorState,
        showLink = _this$state.showLink,
        showVideoLink = _this$state.showVideoLink,
        isEditing = _this$state.isEditing,
        isTooLong = _this$state.isTooLong,
        dragging = _this$state.dragging;
      var _this$props4 = this.props,
        inputRef = _this$props4.inputRef,
        placeholder = _this$props4.placeholder,
        focusEditor = _this$props4.focusEditor,
        handleEdition = _this$props4.handleEdition,
        handleDeletion = _this$props4.handleDeletion,
        minimal = _this$props4.minimal,
        minHeight = _this$props4.minHeight,
        decorators = _this$props4.decorators;
      var isEmpty = editorState.getCurrentContent().getPlainText().replace(/\s/g, '') === '' && editorState.getCurrentContent().getBlockMap().size === 1;
      return React.createElement(Fragment, null, React.createElement(EditorGlobalStyles, null), React.createElement(EditorContainer, {
        hasDrop: decorators.includes('images'),
        dragging: dragging && isEditing,
        minHeight: minHeight,
        hidden: !isEditing && isEmpty,
        isRemovable: !handleEdition && handleDeletion,
        isEditable: handleEdition,
        onDrop: this.handleAddImage,
        onDragOver: this.handleDragOver,
        onDragLeave: this.handleDragLeave,
        onClick: this.handleFocus
      }, decorators.includes('images') && dragging && isEditing ? React.createElement(DragnDrop, null) : null, handleEdition ? isEditing ? React.createElement(EditionButtons, null, React.createElement(CancelButton, {
        handleClick: this.cancelEdition
      }), React.createElement(SaveButton, {
        handleClick: this.saveEdition
      })) : React.createElement(EditionButtons, null, React.createElement(EditButton, {
        handleClick: this.toggleEditing
      }), handleDeletion ? React.createElement(DeleteButton, {
        handleClick: handleDeletion
      }) : null) : null, React.createElement(Editor, {
        ref: inputRef,
        placeholder: placeholder,
        stripPastedStyles: true,
        editorState: this.state.editorState,
        customStyleMap: styleMap,
        blockRenderMap: extendedBlockRenderMap,
        handleKeyCommand: this.handleKeyCommand,
        onChange: this.handleChange,
        onEscape: this.handleEscape,
        onTab: this.handleTab,
        onDownArrow: this.handleDownArrow,
        onUpArrow: this.handleUpArrow,
        handleReturn: this.handleReturn,
        handleDroppedFiles: this.handleDroppedFiles,
        keyBindingFn: keyBindings,
        readOnly: !isEditing,
        blockRendererFn: this.blockRendererFn
      }), isTooLong && isEditing ? this.renderLimit() : null, !handleEdition && handleDeletion ? React.createElement(DeleteContent, {
        handleClick: handleDeletion
      }) : null), isEditing && !minimal ? React.createElement(Toolbar, null, React.createElement("input", {
        type: "file",
        ref: function ref(el) {
          return _this2.fileInput = el;
        },
        onChange: this.handleAddImage,
        hidden: true,
        multiple: true
      }), showLink ? React.createElement(LinkControl, {
        editorState: this.state.editorState,
        onChange: this.handleChange,
        hideLink: this.hideLink,
        focusEditor: focusEditor
      }) : null, showVideoLink ? React.createElement(VideoLinkControl, {
        editorState: this.state.editorState,
        onChange: this.handleChange,
        hideVideoLink: this.hideVideoLink,
        focusEditor: focusEditor,
        handleAddVideo: this.handleAddVideo
      }) : null, React.createElement(EditorControls, {
        editorState: this.state.editorState,
        onToggleBlockType: this.toggleBlockType,
        onToggleInlineStyle: this.toggleInlineStyle,
        onChange: this.handleChange,
        showLink: this.showLink,
        showVideoLink: this.showVideoLink,
        showFileDialog: this.openFileDialog,
        handleAddVideo: this.handleAddVideo
      })) : null);
    }
  }]);
  return EntryEditor;
}(React.Component);
_defineProperty(EntryEditor, "defaultProps", {
  decorators: []
});